/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import logoGreen from '../assets/images/logo-green.svg';

const Logo = styled.a`
  position: ${(props) => (props.top === '0%' ? 'initial' : 'absolute')};
  left: 50%;
  transform: translateX(-50%);
  top: ${(props) => props.top};
  transition: top 0.3s ease-in-out;

  img {
    transition: all 200ms ease-in-out;
    width: ${(props) => props.width};
}

  img:hover {
    transform: scale(1.05);
  }

  @media (max-width: 550px) {
    img {
      width: 150px;
    }
  }
`;

export function AnimatedLogo() {
    const [top, setTop] = useState('70%');
    const [width, setWidth] = useState(180);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setTop('0%');
                setWidth(150);
            } else {
                setTop('65%');
                setWidth(200);
            }
        };

        window.addEventListener('scroll', handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Logo href="/" top={top}>
            <img src={logoGreen} alt="Greenia SLR" width={width} />
        </Logo>
    );
}
